// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bHouses {
  margin-top: 10px;
}

.eDataList_listItemColor {
  display: inline-block;
  height: 18px;
  width: 18px;
  vertical-align: middle;
  margin-right: 3px;
  position: relative;
  /*border: solid 1px #8c8c8c;*/
  border-radius: 50%;
  border: 1px solid #dee2e6;
  cursor: pointer;
}

.eHouseForm_listItemColor {
  display: inline-block;
  height: 26px;
  width: 26px;
  vertical-align: top;
  margin-right: 3px;
  position: relative;
  border: 1px solid #ccc;
  cursor: pointer;
  border-radius: 50%;
}

.eHouseForm_listItemColor.mRemovable:hover:after {
  font-size: 20px;
  content: 'x';
  background: white;
  font-weight: bold;
  border-radius: 50%;
}

.eHouseForm_listItemColor.mRemovable:hover:after {
  position: absolute;
  width: 100%;
  height: 100%;
  line-height: 23px;
  text-align: center;
  font-size: 18px;
  color: #949291;
}

.eHouseForm_IconAdd {
  display: inline-block;
  padding-left: 10px;
  vertical-align: sub;
}

.eHouseFormLogoFrame {
  position: relative;
}
.eHouseFormLogoRemoveBtn {
  position: absolute;
  top: 4px;
  right: 4px;
  background: rgba(255, 255, 255, 0.8);
  border: none;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  font-size: 16px;
  line-height: 20px;
  cursor: pointer;
}
.eHouseFormLogoRemoveBtn:hover {
  background: rgba(255, 255, 255, 1);
}

.modal-dialog.myHouseModal {
  max-width: 600px;
  width: 90%;
}

.myHouseModal .modal-content {
  position: relative;
}

.eHouseForm_modalOverlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 1000;
}

.eHouseForm_ColorEditor {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1001;
  background: #fff;
  padding: 1rem;
  border-radius: 0.25rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
`, "",{"version":3,"sources":["webpack://./src/views/GenericView/AdminView/School/Houses/Houses.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,0CAA0C;AAC5C","sourcesContent":[".bHouses {\n  margin-top: 10px;\n}\n\n.eDataList_listItemColor {\n  display: inline-block;\n  height: 18px;\n  width: 18px;\n  vertical-align: middle;\n  margin-right: 3px;\n  position: relative;\n  /*border: solid 1px #8c8c8c;*/\n  border-radius: 50%;\n  border: 1px solid #dee2e6;\n  cursor: pointer;\n}\n\n.eHouseForm_listItemColor {\n  display: inline-block;\n  height: 26px;\n  width: 26px;\n  vertical-align: top;\n  margin-right: 3px;\n  position: relative;\n  border: 1px solid #ccc;\n  cursor: pointer;\n  border-radius: 50%;\n}\n\n.eHouseForm_listItemColor.mRemovable:hover:after {\n  font-size: 20px;\n  content: 'x';\n  background: white;\n  font-weight: bold;\n  border-radius: 50%;\n}\n\n.eHouseForm_listItemColor.mRemovable:hover:after {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  line-height: 23px;\n  text-align: center;\n  font-size: 18px;\n  color: #949291;\n}\n\n.eHouseForm_IconAdd {\n  display: inline-block;\n  padding-left: 10px;\n  vertical-align: sub;\n}\n\n.eHouseFormLogoFrame {\n  position: relative;\n}\n.eHouseFormLogoRemoveBtn {\n  position: absolute;\n  top: 4px;\n  right: 4px;\n  background: rgba(255, 255, 255, 0.8);\n  border: none;\n  border-radius: 50%;\n  width: 24px;\n  height: 24px;\n  font-size: 16px;\n  line-height: 20px;\n  cursor: pointer;\n}\n.eHouseFormLogoRemoveBtn:hover {\n  background: rgba(255, 255, 255, 1);\n}\n\n.modal-dialog.myHouseModal {\n  max-width: 600px;\n  width: 90%;\n}\n\n.myHouseModal .modal-content {\n  position: relative;\n}\n\n.eHouseForm_modalOverlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: rgba(0, 0, 0, 0.4);\n  z-index: 1000;\n}\n\n.eHouseForm_ColorEditor {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 1001;\n  background: #fff;\n  padding: 1rem;\n  border-radius: 0.25rem;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
